module.exports = __webpack_public_path__ + "assets/e7be82bf0e907575c92ecbe17abc9e6b.svg";